import React from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import DoubleButton from "components/popup/components/DoubleButton";
import DateTimePicker from "components/DateTimePicker";
import DescriptionIcon from '@material-ui/icons/Description';
import TypographyWithIcon from "components/TypographyWithIcon";
import moment from "libs/moment";
import VS from "constants/ValidationShema";
import PropTypes from 'prop-types';

function OfferChoiceResultFilePublishPopup(
    {
        onClose,
        onSubmit,
        offerChoiceResultItem,
        formSubmit,
    }) {

    const {publishUntilDate} = offerChoiceResultItem;

    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();

    return (
        <Dialog
            title={Tr('publish_until_data')}
            open={true}
            maxWidth={'xs'}
            dialogActions={<DoubleButton
                justify='flex-end'
                labelFirst={Tr('cancel')}
                labelSecond={Tr('confirm')}
                onClickFirst={onClose}
                onClickSecond={handleSubmit}
            />}
        >

            <Form
                initialValues={{
                    publishUntilDate: publishUntilDate ? moment(publishUntilDate) : null,
                }}
                validationSchema={Yup.object().shape({
                    publishUntilDate: VS.dateTimeMinNoRq(new Date(), Tr("v_data_can_not_be_past"))
                })}
                onSubmit={onSubmit}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>

                        <TypographyWithIcon Icon={DescriptionIcon}>
                            {Tr(offerChoiceResultItem.modification ? 'offers_choice_modification_result_applies_parts' : 'offers_choice_result_applies_parts')}: {offerChoiceResultItem.positionOrders.join(", ")}
                        </TypographyWithIcon>

                        <DateTimePicker
                            formikProps={formikProps}
                            id='publishUntilDate'
                            label={Tr('repo_visibility_end_date')}
                        />
                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

OfferChoiceResultFilePublishPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    offerChoiceResultItem: PropTypes.shape({
        modification: PropTypes.bool.isRequired,
        publishUntilDate: PropTypes.string,
        positionOrders: PropTypes.arrayOf(PropTypes.number).isRequired
    })
}

export default connect((state) => ({
    formSubmit: state.form,
}), {})(OfferChoiceResultFilePublishPopup);